import { AsyncBoundary } from "@src/components/AsyncBoundary";
import { Stack } from "@src/components/Stack";
import type { Color } from "@src/types/styleType";
import { type ReactNode } from "react";

/**
 * @param {ReactNode} children - children
 * @param {Color} bgColor - background color
 * @param {Color} border - border bottom color
 */
export const WithPageContainer = ({
  children,
  bgColor = "white",
  useErrorBoundary = true
}: {
  children: ReactNode;
  bgColor?: Color;
  useErrorBoundary?: boolean;
}) => {
  return (
    <Stack className={`tw-min-h-full bg-${bgColor}`}>
      <>
        {useErrorBoundary ? (
          <AsyncBoundary>{children}</AsyncBoundary>
        ) : (
          children
        )}
      </>
    </Stack>
  );
};
